module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_7.55ab4d9d.jpg";